import { Typography } from '@material-ui/core';
import MaskedOutput from 'components/MaskedOutput';
import PermissionHide from 'components/PermissionHide';
import React, { PureComponent } from 'react';

import type { ICDFList } from 'store/Orbita/FiscalDocuments/interfaces';

interface IProps {
  data: ICDFList[0]['list'][0]['customer_origin'] | ICDFList[0]['list'][0]['destination_customer'];
}

export default class Customer extends PureComponent<IProps, {}> {
  cleanupCaracteres = (value: string) => {
    return value.replace(/(^[,-\s]+|[-,\s]+$|\s{2,}|\n)/gi, ' ').trim();
  };

  get address() {
    const { data } = this.props;
    return this.cleanupCaracteres(
      !data.address
        ? ''
        : `${data.address.street || ''},
        ${data.address.number || ''} ${data.address.complement || ''} -
        ${data.address.neighborhood || ''}`
    );
  }

  get cityState() {
    const { data } = this.props;
    return this.cleanupCaracteres(!data.address ? '' : `${data.address.city || ''}/${data.address.state || ''}`);
  }

  get phones() {
    const { data } = this.props;
    return this.cleanupCaracteres(`${data.phone || ''}/${data.cellphone || ''}`);
  }

  render() {
    const { data } = this.props;

    return (
      <div>
        <Typography>
          <strong>Razão Social: </strong>
          {data.name}
        </Typography>
        <Typography>
          <strong>CNPJ/CPF: </strong>
          <MaskedOutput mask='cpfCnpj' value={data.document_number} />
        </Typography>
        <Typography>
          <strong>IE: </strong>
          <PermissionHide action='myeduzz:cdf:ver-dados-clientes'>{data.state_register}</PermissionHide>
          <PermissionHide inverse action='myeduzz:cdf:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </Typography>
        <Typography>
          <strong>IM: </strong>
          <PermissionHide action='myeduzz:cdf:ver-dados-clientes'>{data.municipal_register || '-'}</PermissionHide>
          <PermissionHide inverse action='myeduzz:cdf:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </Typography>
        <Typography>
          <strong>E-mail: </strong>
          <PermissionHide action='myeduzz:cdf:ver-dados-clientes'>{data.email}</PermissionHide>
          <PermissionHide inverse action='myeduzz:cdf:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </Typography>
        <Typography>
          <strong>Endereço: </strong>
          <PermissionHide action='myeduzz:cdf:ver-dados-clientes'>{this.address}</PermissionHide>
          <PermissionHide inverse action='myeduzz:cdf:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </Typography>
        <Typography>
          <strong>Cidade/UF: </strong>
          <PermissionHide action='myeduzz:cdf:ver-dados-clientes'>{this.cityState}</PermissionHide>
          <PermissionHide inverse action='myeduzz:cdf:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </Typography>
        <Typography>
          <strong>Telefones: </strong>
          <PermissionHide action='myeduzz:cdf:ver-dados-clientes'>{this.phones}</PermissionHide>
          <PermissionHide inverse action='myeduzz:cdf:ver-dados-clientes'>
            <em>oculto</em>
          </PermissionHide>
        </Typography>
      </div>
    );
  }
}
